import { paths } from '../types';
import { useQueryClient, Updater } from '@tanstack/react-query';
import { FetchOptions, FetchResponse } from 'openapi-fetch';
import type {
  FilterKeys,
  PathsWithMethod,
  HasRequiredKeys,
  HttpMethod
} from 'openapi-typescript-helpers';
import { getTypedQueryKey } from './getTypedQueryKey';

type SetCacheUpdaterFunction<T> = Updater<
  FetchResponse<T>['data'],
  FetchResponse<T>['data'] | undefined
>;

// eslint-disable-next-line @typescript-eslint/ban-types
type CreateUseTypedSetCache<Paths extends {}> = {
  useTypedSetCache<T extends HttpMethod, P extends PathsWithMethod<Paths, T>>(
    _method: T,
    _url: P,
    ..._options: HasRequiredKeys<
      FetchOptions<FilterKeys<Paths[P], T>>
    > extends never
      ? [(FetchOptions<FilterKeys<Paths[P], T>> | undefined)?]
      : [FetchOptions<FilterKeys<Paths[P], T>>]
  ): (
    _updater: SetCacheUpdaterFunction<
      T extends keyof Paths[P] ? Paths[P][T] : unknown
    >
  ) => void;
};

export const createUseTypedSetCache: CreateUseTypedSetCache<paths> = {
  useTypedSetCache(_method, url, ...options) {
    const queryClient = useQueryClient();
    const option = options[0];

    return (updater) =>
      queryClient.setQueryData(
        // @ts-expect-error option is ok
        getTypedQueryKey(url, option),
        // @ts-expect-error updater is ok
        updater
      );
  }
};

export const useTypedSetCache = createUseTypedSetCache.useTypedSetCache;
